var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MessageContent } from "../../Organisms/Messages/Molecules";
import { Stack, Link } from "@mui/material";
import { Text } from "../../Atoms/";
import { COLORS } from "../../../constants/colors";
var ForgotPasswordConfirmation = function (_a) {
    var _b = _a.message, message = _b === void 0 ? "We've sent you an email with a link to reset your password. If you do not receive an email within a few minutes please contact support." : _b;
    return (_jsx(MessageContent, __assign({ title: "Password reset email sent" }, { children: _jsxs(Stack, __assign({ direction: "column", spacing: 6, pt: 2, textAlign: "center" }, { children: [_jsx(Text, __assign({ variant: "body1" }, { children: message })), _jsx(Text, __assign({ variant: "body2" }, { children: _jsx(Link, __assign({ href: "mailto:support@saytechnologies.com?subject=Password reset email issue", target: "_blank", rel: "noreferrer", color: COLORS.SHADED_COBALT, underline: "none", sx: {
                            fontWeight: 600,
                        } }, { children: "Contact Say Support" })) }))] })) })));
};
export default ForgotPasswordConfirmation;
